module.exports = __webpack_public_path__ + "img/header_hoken.e20eb780.png";